import { Clock, Loader2, CheckCircle2, XCircle } from 'lucide-react';

import { Badge } from '@/components/ui/Badge';
import { ExportStatus } from '@/services/VoiceTone';

interface ExportStatusBadgeProps {
  status: ExportStatus;
}

export function ExportStatusBadge({ status }: ExportStatusBadgeProps) {
  const statusConfig = {
    active: {
      label: 'active',
      variant: 'secondary' as const,
      icon: Loader2,
      className: 'bg-muted text-muted-foreground',
    },
    waiting: {
      label: 'waiting',
      variant: 'secondary' as const,
      icon: Loader2,
      className: 'bg-muted text-muted-foreground',
    },
    completed: {
      label: 'completed',
      variant: 'default' as const,
      icon: CheckCircle2,
      className:
        'bg-green-100 text-green-700 dark:bg-green-950 dark:text-green-300',
    },
    failed: {
      label: 'failed',
      variant: 'destructive' as const,
      icon: XCircle,
      className: 'bg-red-100 text-red-700 dark:bg-red-950 dark:text-red-300',
    },
  };

  const config = statusConfig[status];
  const Icon = config.icon || Clock;

  return (
    <Badge variant={config.variant} className={config.className}>
      <Icon
        className={`mr-1.5 size-3 ${status === ExportStatus.ACTIVE || status === ExportStatus.WAITING ? 'animate-spin' : ''}`}
      />
      {config.label}
    </Badge>
  );
}
